export class EdgeServer {
  constructor(
    public id: number,
    public name: string,
    public ip: string,
    public availabilityZoneId: number,
  ) {}
}
